var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" Admins ")]),_c('v-card-text',_vm._l((_vm.list),function(person,i){return _c('v-list-item',{key:i},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(person.name)+" ")])],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }